// import React, {useEffect} from "react";

// const Checkbox = ({ id, type, name, handleClick, isCheckAll }) => {

//   useEffect( ()=> {
//     // console.log('ischeck all',isCheckAll)
// },[isCheckAll])

//   return (
//     <div>
//     <input
//       id={id}
//       name={name}
//       type={type}
//       onChange={handleClick}
//       checked={isCheckAll}
//       // className="select-individual-check"
//     />
//     </div>
//   );
// };

// export default Checkbox;



import React from "react";

const Checkbox = ({ id, type, name, handleClicks, isChecked }) => {
  return (
    <input
      id={id}
      name={name}
      type={type}
      onChange={handleClicks}
      checked={isChecked}
    />
  );
};

export default Checkbox;
